import BenchmarkStudyService from 'src/modules/benchmarkStudy/benchmarkStudyService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'BENCHMARKSTUDY_FORM';

const benchmarkStudyFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: benchmarkStudyFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await BenchmarkStudyService.find(id);
      }

      dispatch({
        type: benchmarkStudyFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: benchmarkStudyFormActions.INIT_ERROR,
      });

      getHistory().push('/benchmark-study');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: benchmarkStudyFormActions.CREATE_STARTED,
      });

      await BenchmarkStudyService.create(values);

      dispatch({
        type: benchmarkStudyFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.benchmarkStudy.create.success'),
      );

      getHistory().push('/benchmark-study');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: benchmarkStudyFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: benchmarkStudyFormActions.UPDATE_STARTED,
      });

      await BenchmarkStudyService.update(id, values);

      dispatch({
        type: benchmarkStudyFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.benchmarkStudy.update.success'),
      );

      getHistory().push('/benchmark-study');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: benchmarkStudyFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default benchmarkStudyFormActions;
